import React from 'react';
import './HomePromo.css'; 
import book from '../../media/mumslife.png';
import {homePromos} from '../../content/home/homePromos';

const ACCORDION_ID = 'homePromoAccordion';

const imageMap = {
  mumslife: book,
};

function HomePromo() {
  const promo = homePromos.find((p) => p.enabled);

  // If nothing is enabled, show nothing.
  if (!promo) return null;

  const {intro, accordions, image} = promo;

  return (
    <div className='currentNews mt-5 p-3 pe-5'>
      <div className='republish'>
        <div className='col-5 bookImages'>
          <img
            src={imageMap[image.key]}
            alt={image.alt}
            className='img-fluid pt-4 book1'
          />
        </div>

        <div className='col-7 newText'>
          {intro.textBeforeLink}{' '}
          <a
            href={intro.linkUrl}
            target='_blank'
            rel='noreferrer'
            className='py-1 px-2 linkLightBase'>
            {intro.linkText}
          </a>{' '}
          {intro.textAfterLink}
          <p />
          <div
            className='accordion custom-accordion mt-2'
            id={ACCORDION_ID}>
            {accordions.map((section) => {
              const headingId = `heading-${promo.id}-${section.id}`;
              const collapseId = `collapse-${promo.id}-${section.id}`;

              return (
                <div
                  className='accordion-item'
                  key={section.id}>
                  <h2
                    className='accordion-header'
                    id={headingId}>
                    <button
                      className='accordion-button collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target={`#${collapseId}`}
                      aria-expanded='false'
                      aria-controls={collapseId}>
                      {section.title}
                    </button>
                  </h2>

                  <div
                    id={collapseId}
                    className='accordion-collapse collapse'
                    aria-labelledby={headingId}
                    data-bs-parent={`#${ACCORDION_ID}`}>
                    <div className='accordion-body'>
                      <p className='mb-0'>
                        {section.links.map((link) => (
                          <a
                            key={link.url}
                            href={link.url}
                            target='_blank'
                            rel='noreferrer'
                            className='py-1 px-2 linkLightBase introLink'>
                            <u>{link.label}</u>
                          </a>
                        ))}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomePromo;
